import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // 状态
      user: null,
      token: typeof window !== 'undefined' ? (localStorage.getItem('token') || null) : null,
      isAuthenticated: typeof window !== 'undefined' ? !!localStorage.getItem('token') : false,
      loading: false,
      error: null,

      // 设置用户信息
      setUser: (user) => set({ user, isAuthenticated: !!user || !!get().token }),
      
      // 设置token，同时同步到 localStorage 'token' 以兼容小程序同款逻辑
      setToken: (token) => {
        if (typeof window !== 'undefined') {
          if (token) {
            localStorage.setItem('token', token);
          } else {
            localStorage.removeItem('token');
          }
        }
        set({ token, isAuthenticated: !!token || get().isAuthenticated });
      },
      
      // 设置加载状态
      setLoading: (loading) => set({ loading }),
      
      // 设置错误信息
      setError: (error) => set({ error }),
      
      // 登录
      login: async (credentials) => {
        set({ loading: true, error: null });
        try {
          // 这里应该调用实际的API
          const response = await fetch('/api/auth/login', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials),
          });
          
          if (!response.ok) {
            throw new Error('登录失败');
          }
          
          const data = await response.json();
          set({
            user: data.user,
            token: data.token,
            isAuthenticated: true,
            loading: false,
          });
          
          return data;
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },

      // 注册
      register: async (userData) => {
        set({ loading: true, error: null });
        try {
          const response = await fetch('/api/auth/register', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
          });
          
          if (!response.ok) {
            throw new Error('注册失败');
          }
          
          const data = await response.json();
          set({
            user: data.user,
            token: data.token,
            isAuthenticated: true,
            loading: false,
          });
          
          return data;
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },

      // 发送验证码
      sendVerificationCode: async (phone) => {
        set({ loading: true, error: null });
        try {
          const response = await fetch('/api/auth/send-code', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ phone }),
          });
          
          if (!response.ok) {
            throw new Error('发送验证码失败');
          }
          
          set({ loading: false });
          return await response.json();
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },

      // 验证手机号
      verifyPhone: async (phone, code) => {
        set({ loading: true, error: null });
        try {
          const response = await fetch('/api/auth/verify-phone', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ phone, code }),
          });
          
          if (!response.ok) {
            throw new Error('验证码错误');
          }
          
          const data = await response.json();
          set({
            user: data.user,
            token: data.token,
            isAuthenticated: true,
            loading: false,
          });
          
          return data;
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },

      // 登出
      logout: () => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('token');
        }
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          error: null,
        });
      },

      // 清除错误
      clearError: () => set({ error: null }),

      // 微信登录
      loginWithWeChat: async (userData) => {
        set({ loading: true, error: null });
        try {
          // 设置用户信息和token
          set({
            user: userData.user,
            token: userData.token,
            isAuthenticated: true,
            loading: false,
          });
          
          return userData;
        } catch (error) {
          set({ error: error.message, loading: false });
          throw error;
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        user: state.user,
        token: state.token,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAuthStore; 